













































import { Component, Vue } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { formatString } from '@/services/StringFormatter';
import ItemImage from '@/components/itemComponents/ItemImage.vue';

@Component({
  props: {
    item: Object,
  },
  components: {
    ItemImage,
  },
  methods: {
    formatString,
  },
})
export default class ItemComponent extends Vue {
  @State
  public isDisplayList!: boolean;
  @Getter
  public getItemDescriptionByLanguage!: any;
  @Getter
  public getItemNameByLanguage!: any;
  @Getter
  private kmK!: string;
  @Getter
  private kmUrlBase!: string;
}
